import { useQuery } from "@tanstack/react-query";
import { Info } from "lucide-react";
import api from "@/lib/api";
import { buildNav, NAV_CAP } from "@/lib/navLayout";

const Bar = ({ title, cap, items, pages, testid }) => {
  const { primaryLinks, exploreLinks } = buildNav(items.filter((i) => i.visible !== false), pages, cap);
  return (
    <div className="mb-4" data-testid={testid}>
      <p className="text-xs font-semibold text-[#4A5D6B] uppercase tracking-wide mb-1.5">{title}</p>
      <div className="rounded-xl bg-[#144F75] text-white px-4 py-2.5 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm">
        {primaryLinks.map((l) => <span key={l.to} className="whitespace-nowrap">{l.label}</span>)}
        <span className="whitespace-nowrap text-white/80">Explore ▾</span>
      </div>
      <div className="mt-1.5 text-xs text-[#4A5D6B]">
        <span className="font-medium">In Explore:</span>{" "}
        {exploreLinks.length ? exploreLinks.map((l, i) => (
          <span key={`${l.to}-${i}`} className={l.overflow ? "text-[#B4664B]" : ""}>
            {l.label}{l.overflow ? " (no room in top bar)" : ""}{i < exploreLinks.length - 1 ? ", " : ""}
          </span>
        )) : "nothing"}
      </div>
    </div>
  );
};

// Live preview of how the saved/unsaved menu will look on the site.
export const NavPreview = ({ items }) => {
  const { data: pages = [] } = useQuery({ queryKey: ["nav-pages"], queryFn: () => api.get("/pages").then((r) => r.data.filter((p) => p.show_in_nav)) });
  return (
    <div className="eyw-card !p-5 mt-6" data-testid="nav-preview">
      <h3 className="font-serif text-xl text-[#1A242B] mb-3">Preview</h3>
      <Bar title={`Top bar — same for everyone (fits ${NAV_CAP} links)`} cap={NAV_CAP} items={items} pages={pages} testid="nav-preview-visitor" />
      <p className="text-xs text-[#8FA89B] flex gap-1.5"><Info size={13} className="shrink-0 mt-0.5" />
        Links show in exactly the order and group you set here. Top-bar links past the limit move into Explore. Saved changes appear on the live site within a few seconds.</p>
    </div>
  );
};
